import React, { useCallback, useMemo } from 'react'
import { deleteCookie, inIframe, useEffectOnce, usePathParam } from '@chilecompra/react-kit'
import { REACT_APP_BASE_URL, REACT_APP_MERCADO_PUBLICO_BASE_URL } from '../config/settings/environment'
import { PATH_PARAM } from '../config/settings/regexes'
import routes from '../config/settings/routes'
import AuthorizationContext from '../containers/AuthorizationProvider/AuthorizationProvider.context'
import AuthorizationProviderContainer from '../containers/AuthorizationProvider/AuthorizationProvider.container'
import HeadingSectionContainer from '../containers/Sanction/SanctionHeader.container'
import SanctionAttachmentsContainer from '../containers/Sanction/SanctionAttachments.container'
import SanctionDetailsFormContainer from '../containers/Sanction/SanctionDetailsForm.container'
import SanctionDetailsFooterContainer from '../containers/Sanction/SanctionDetailsFooter.container'
import SanctionHeadingContainer from '../containers/Sanction/SanctionHeadingSection.container'
import SanctionPOBiddingContainer from '../containers/Sanction/SanctionPOBidding.container'
import BrandLayout from '../components/Layouts/BrandLayout'
import ProtectByFeatures from '../components/Security/ProtectByFeatures'
import NotFoundPage from '../pages/NotFound'

/**
 * The Sanction Details' page.
 */
const SanctionDetails = () => {
  const dni = usePathParam('rut')

  const breadcrumbs = useCallback(userType => {
    return [
      {
        text: 'Escritorio',
        link: `${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Portal/Modules/Menu/Menu.aspx`,
        isExternal: true,
        onClick: handleClickHome
      },
      userType !== 'Proveedor' && {
        text: 'Búsqueda Proveedor',
        link: `${REACT_APP_BASE_URL}/busqueda`,
        isExternal: true
      },
      {
        text: dni,
        link: routes.contractualBehavior.replace(PATH_PARAM, dni),
        isExternal: false
      },
      {
        text: 'Detalle sanción'
      }
    ].filter(Boolean)
  }, [])

  const handleClickHome = event => {
    event.preventDefault()
    deleteCookie('access_token')
    window.open(`${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Portal/Modules/Menu/Menu.aspx`, '_top')
  }

  const isInIframe = useMemo(() => {
    return inIframe()
  }, [])

  useEffectOnce(() => {
    if (isInIframe) {
      window.parent.postMessage(
        {
          action: 'scrollTo',
          value: {
            x: 0,
            y: 0
          }
        },
        REACT_APP_MERCADO_PUBLICO_BASE_URL
      )
    } else {
      window.scrollTo(0, 0)
    }
  })

  return (
    <ProtectByFeatures rule={features => features['com.seller/contractual.behavior']} fallback={() => <NotFoundPage />}>
      <AuthorizationProviderContainer>
        <AuthorizationContext.Consumer>
          {({ userType }) => (
            <ProtectByFeatures
              rule={features => features['com.seller/historical.sanctions']}
              fallback={() => <NotFoundPage />}
            >
              <BrandLayout featured={<HeadingSectionContainer breadcrumbs={breadcrumbs(userType)} />}>
                <SanctionHeadingContainer />
                <SanctionPOBiddingContainer />
                <SanctionDetailsFormContainer />
                <SanctionAttachmentsContainer />
                <SanctionDetailsFooterContainer />
              </BrandLayout>
            </ProtectByFeatures>
          )}
        </AuthorizationContext.Consumer>
      </AuthorizationProviderContainer>
    </ProtectByFeatures>
  )
}

export default SanctionDetails
